export enum EUrls {
  BUSINESS_CUSTOMERS = '/business-customers'
}
